import PropTypes from "prop-types";
import React, { useState } from "react";
import { Modal, Button } from "react-bootstrap";

const Video = (props) => {
  const { setting } = props;
  const [hasError, setHasError] = useState(false);

  // Function to convert regular YouTube URL to embed URL
  const getEmbedUrl = (url) => {
    if (!url) {
      return null;
    }

    // YouTube (supports youtube.com & youtu.be)
    const youtubeRegex =
      /(?:youtube\.com.*[?&]v=|youtu\.be\/)([a-zA-Z0-9_-]{11})/;

    const youtubeMatch = url.match(youtubeRegex);
    if (youtubeMatch) {
      return `https://www.youtube.com/embed/${youtubeMatch[1]}?autoplay=0&controls=1&modestbranding=1&rel=0`;
    }

    // Vimeo
    const vimeoRegex = /vimeo\.com\/(\d+)/;
    const vimeoMatch = url.match(vimeoRegex);
    if (vimeoMatch) {
      return `https://player.vimeo.com/video/${vimeoMatch[1]}?autoplay=0&title=0&byline=0&portrait=0`;
    }

    // Already an embed/player URL
    if (url.includes("embed") || url.includes("player")) {
      return url;
    }

    return url;
  };

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered className="calendar-modal"
    >
      <Modal.Header closeButton></Modal.Header>
      <Modal.Body>
        <div className="video-container" style={{ position: 'relative', paddingBottom: '56.25%', height: 0, overflow: 'hidden' }}>
          {hasError || !setting?.video_link ? (
            <div style={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              textAlign: 'center',
              width: '100%'
            }}>
              <p>Sorry, there was an error loading the video.</p>
              <p>Please try again later.</p>
            </div>
          ) : (
            <iframe
              src={getEmbedUrl(setting.video_link)}
              style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                border: 'none'
              }}
              allow="autoplay; encrypted-media; picture-in-picture"
              allowFullScreen
              title="Video Player"
              onError={() => setHasError(true)}
            />
          )}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={props.onHide}>Close</Button>
      </Modal.Footer>
    </Modal>
  );
};

Video.propTypes = {
  setting: PropTypes.shape({
    video_link: PropTypes.string,
  }).isRequired,
  onHide: PropTypes.func.isRequired,
};

export default Video;
